export const groupServices = [
  {
    id: "pro-estate",
    code: "01",
    brand: "PRO ESTATE",
    nameJa: "不動産管理",
    nameEn: "Real Estate Management",
    taglineJa: "不動産売買・賃貸のトータルサポート",
    taglineEn: "Full-cycle support for property sales & leasing",
    descriptionJa:
      "都心マンション・投資用物件・法人向け社宅など、売買から賃貸管理までワンストップで対応。宅建士・不動産経営士が資産価値の最大化を支援します。",
    descriptionEn:
      "From acquisition and disposition to leasing and asset management for downtown residences, investment properties and corporate housing.",
    icon: "ri-building-4-line",
    accent: "primary",
  },
  {
    id: "prosku",
    code: "02",
    brand: "PROSKU",
    nameJa: "保育専門事務",
    nameEn: "Nursery Back-Office",
    taglineJa: "看護師資格スタッフによる保育施設向け事務支援",
    taglineEn: "Nurse-led administrative support for nurseries",
    descriptionJa:
      "認可・認証保育所の運営に精通した看護師資格保持者が、労務・登降園管理・保護者対応・保健業務など保育現場特有の事務をまるごと巻き取ります。",
    descriptionEn:
      "Registered-nurse operators take over labor, attendance, parent communication and health administration unique to childcare sites.",
    icon: "ri-parent-line",
    accent: "secondary",
  },
  {
    id: "marketing-quest",
    code: "03",
    brand: "Marketing Quest",
    nameJa: "マーケティング支援",
    nameEn: "Growth Marketing",
    taglineJa: "経験豊富なマーケターによる課題解決",
    taglineEn: "Senior marketers solving your growth bottlenecks",
    descriptionJa:
      "大手事業会社・広告代理店出身のマーケターが、事業戦略・チャネル設計・広告運用・データ分析まで、事業成長のボトルネックを解きほぐします。",
    descriptionEn:
      "Ex-enterprise and agency marketers cover strategy, channel design, media buying and analytics — end-to-end growth work.",
    icon: "ri-line-chart-line",
    accent: "primary",
  },
  {
    id: "enghouse",
    code: "04",
    brand: "EngHouse",
    nameJa: "英語塾 & 英語託児",
    nameEn: "English School & Childcare",
    taglineJa: "平日夜間・土日対応。英語による託児所も展開",
    taglineEn: "Weeknights & weekends. Includes English-only childcare",
    descriptionJa:
      "共働き家庭のスケジュールに寄り添い、平日夜間・土日に英語レッスンを提供。英語のみで運営する託児サービスも併設し、幼少期からの英語環境を実現します。",
    descriptionEn:
      "Weeknight and weekend English classes for busy families, plus an English-immersion childcare service for early exposure.",
    icon: "ri-translate-2",
    accent: "accent",
  },
  {
    id: "prodesign",
    code: "05",
    brand: "ProDesign",
    nameJa: "SNS運用 / Webデザイン",
    nameEn: "SNS Marketing & Web Design",
    taglineJa: "SNS投稿画像作成・Webデザインを一括サポート",
    taglineEn: "Social visuals and web design in one package",
    descriptionJa:
      "Instagram・X・LinkedInの投稿クリエイティブから、ランディングページ・コーポレートサイトのデザインまで、ブランドの世界観を一貫して設計・運用します。",
    descriptionEn:
      "Post-level creative for Instagram / X / LinkedIn plus landing pages and corporate site design, all under one brand voice.",
    icon: "ri-palette-line",
    accent: "primary",
  },
  {
    id: "pro-online",
    code: "06",
    brand: "ProOnline",
    nameJa: "オンライン事務代行",
    nameEn: "Online Back-Office",
    taglineJa: "必要な時間だけ依頼できるオンライン秘書サポート",
    taglineEn: "Pay-as-you-need online administrative support",
    descriptionJa:
      "UbiProの前身事業。経理・スケジュール調整・資料作成・顧客対応など、必要な時間だけスポットで依頼できる、オンライン専業の秘書チーム。",
    descriptionEn:
      "The origin business of UbiPro. Accounting, scheduling, document prep and customer support delivered by an online-only team on demand.",
    icon: "ri-computer-line",
    accent: "secondary",
  },
];

export const processSteps = [
  {
    step: "01",
    titleJa: "お問い合わせ",
    titleEn: "Inquiry",
    descJa: "フォームまたはご紹介経由でご連絡ください。担当が1営業日以内に返信します。",
    descEn: "Reach out via form or referral. We reply within one business day.",
    icon: "ri-mail-send-line",
  },
  {
    step: "02",
    titleJa: "ヒアリング",
    titleEn: "Discovery",
    descJa: "現状の課題・体制・ゴールをオンライン30〜60分で丁寧にお伺いします。",
    descEn: "A 30–60 minute online session to understand your current state and goal.",
    icon: "ri-chat-check-line",
  },
  {
    step: "03",
    titleJa: "ご提案",
    titleEn: "Proposal",
    descJa: "最適なグループ内サービスを組み合わせ、スコープ・体制・見積を提示します。",
    descEn: "We combine group services and present scope, team and quote.",
    icon: "ri-file-list-3-line",
  },
  {
    step: "04",
    titleJa: "ご契約",
    titleEn: "Agreement",
    descJa: "契約書とNDAを締結。オンライン完結で、最短で契約翌営業日から着手可能です。",
    descEn: "Sign contract and NDA online. Work can start as early as the next business day.",
    icon: "ri-shield-check-line",
  },
  {
    step: "05",
    titleJa: "サービス開始",
    titleEn: "Kick-off",
    descJa: "専任チームがアサインされ、定例MTGを設定。進捗と成果を可視化して伴走します。",
    descEn: "Your dedicated team starts, with recurring reviews and transparent reporting.",
    icon: "ri-rocket-2-line",
  },
];

export const foundingBackground = [
  { ja: "Google 出身", en: "ex-Google" },
  { ja: "日本M&A出身", en: "ex-Nihon M&A Center" },
  { ja: "大手商社出身", en: "ex-Sogo Shosha (Trading House)" },
];